import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ThemeService } from './services/setting/theme.service';
import { SettingService } from './services/setting/setting.service';
import { AppService } from './core/app.service';

const CODE_COLOR_THEME = 'COLOR_THEME';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'ceb-front';
  username: string | undefined;
  roles: string[] = [];
  groups: string[] = [];

  constructor(
    private authService: AuthService,
    private themeService: ThemeService,
    private settingService: SettingService,
    private appService: AppService,
  ) {
    this.themeService.init();
    this.loadColorTheme();
  }

  /** S8 — Charge COLOR_THEME et l'applique par-dessus les valeurs de code
   *  (tokens.scss.ts), avant le premier rendu significatif. */
  private loadColorTheme(): void {
    const appId = this.appService.getAppId();
    this.settingService.getSystemBrand(appId).subscribe({
      next: (data) => {
        if (!data) return;
        const colorDetail = (data.listeDetailsParametres ?? [])
          .find(d => d.code === CODE_COLOR_THEME);
        if (colorDetail?.valeurJson) {
          try {
            const parsed = JSON.parse(colorDetail.valeurJson);
            this.themeService.applyBrandColors(parsed);
          } catch (e) {
            console.error('COLOR_THEME valeurJson invalide au bootstrap', e);
          }
        }
      },
      error: (err) => console.error('Échec chargement COLOR_THEME au bootstrap', err),
    });
  }

  ngOnInit(): void {
    if (!this.authService.isInitialized()) {
      this.authService.init().then(() => {
        this.username = this.authService.getUsername();
        this.roles = this.authService.getRealmRoles();
        this.groups = this.authService.getGroupsFromToken();
        // Debug: log token info
        try {
          // tokenParsed may be undefined; guard
          const parsed = this.authService.getTokenParsed();
          //console.info('Keycloak token parsed after init:', parsed);
          const token = this.authService.getToken();
         /*  console.info('Keycloak raw token present:', !!token); */
        } catch (e) {
          //console.warn('Unable to log Keycloak token parsed info', e);
        }
      }).catch((error) => {
        console.error('Erreur lors de l\'initialisation de du SSO :', error);
      });
    } else {
      // Already initialized by APP_INITIALIZER
      this.username = this.authService.getUsername();
      this.roles = this.authService.getRealmRoles();
      this.groups = this.authService.getGroupsFromToken();
      try {
        const parsed = this.authService.getTokenParsed();
        //console.info('Keycloak token parsed (already initialized):', parsed);
        const token = this.authService.getToken();
        /*  console.info('Keycloak raw token present:', !!token); */
      } catch (e) {
        console.warn('Unable to log SSO token parsed info', e);
      }
    }
  }

  logout(): void {
    this.authService.logout();
  }
}